import styled from 'styled-components';

export const ProcedureInfoWrapper = styled.div`
  position: relative;
  top: -20px;
  background-color: #fff;
  width: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  color: '#2b2727';
  .formEl {
    width: 100%;
    margin-top: 16px;
    font-weight: bold;
  }
  .form-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 15px;
  }
  .textBox {
    width: 100%;
    margin-bottom: 33px;
  }
  .checkbox-form-label {
    margin-right: 17px;
  }
  .other-form-wrapper {
    display: flex;
    flex-direction: column;
    padding: 5px;
    margin-top: 19px;
    width: 100%;
  }
  .is-insured-sued {
    display: flex;
    flex-direction: column;
  }
  .checkbox-form-label {
    font-size: 13px;
    margin-bottom: 16px;
  }

  // material ui native classes
  .MuiFormLabel-root,
  .MuiFormControlLabel-label {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .MuiRadio-colorPrimary {
    width: 18px;
    height: 18px;
    margin: 0 8px;
  }
`;

export const CivilPartyWrapper = styled.div`
  padding: 20px;
  .victims-title {
    text-align: left;
    font-size: 13px;
    color: #2b2727;
    margin: 16px 0;
  }
  .victims-wrapper {
    display: flex;
    flex-direction: column;
  }
  .checkbox-wrapper {
    width: 140px;
    padding: 0 10px;
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 36px;
    color: #2b2727;
    margin: 8px 0px;
    display: flex;
  }
  .checkbox {
    width: 18px;
    height: 18px;
  }
  .MuiFormControlLabel-label {
    font-weight: bold;
    font-size: 13px;
    margin-left: 10px;
  }
`;

export const JudgementAddFormDrawerStyle = styled.main`
  display: flex;
  flex-direction: column;
  padding: 16px;
  .infoBloc {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    margin-bottom: 16px;
    width: 100%;
    font-size: 11px;
  }
  .MuiInputLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .field {
    margin: 10px 0;
    width: 100%;
    font-size: 13px;
    color: #2b2727;
    font-weight: bold;
  }
  .expertise-bloc {
    display: block;
  }
  .expertise-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-bottom: 16px;
  }
  .checkbox-section {
    padding: 10px 0;
    margin: 8px 0;
  }
  .checkbox-wrapper {
    margin: 16px 0 24px 0;
  }
  .checkbox-bloc {
    padding: 0 20px;
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 36px;
    color: #2b2727;
    margin: 8px 0;
  }
  .checkbox {
    width: 18px;
    height: 18px;
  }
  .MuiFormControlLabel-label {
    font-weight: bold;
    font-size: 13px;
    margin-left: 10px;
  }
`;
